<template>
  <div class="tj-container">
    <div class="left-wrapper">
      <div class="left-top">
        <!-- 全身 -->
        <Live2d
          v-if="showType == '0_0'"
          :key="currentStyle.key"
          :dataSource="currentStyle.live2d.full"
          animation="idle"
        />
        <!-- live2d -->
        <Live2d
          v-if="showType == '0_1'"
          :key="currentStyle.key"
          :dataSource="currentStyle.live2d.cover"
          animation="cover_idle"
        />
        <!-- 瞄准 -->
        <Live2d
          v-if="showType == '0_2'"
          :key="currentStyle.key"
          :dataSource="currentStyle.live2d.aim"
          animation="aim_idle"
        />
        <!-- 立绘 -->
        <LH v-if="showType == '1'" :key="currentStyle.key" :dataSource="currentStyle.lh" />
        <!-- 语音 -->
        <Voice
          v-if="showType == '2'"
          :key="currentStyle.key"
          :dataSource="currentStyle.voices"
          :lhDataSource="currentStyle.lh"
        />
        <!-- sd模型 -->
        <SDModel v-if="showType == '3'" :key="currentStyle.key" :dataSource="currentStyle.SDModel" />
        <!-- 大招动画 -->
        <Dzdh v-if="showType == '4'" :key="currentStyle.key" :dataSource="currentStyle.dzdh" />

        <!-- 切换选项 -->
        <SwitchOptions
          :currentStyle="currentStyle"
          :dataSource="dataSource.style"
          @handleSwitch="handleSwitch"
          @switchStyle="switchStyle"
        />
      </div>
      <div class="left-bottom" v-if="['0_0', '0_1', '0_2', '1'].includes(showType)">
        <Slogan :dataSource="currentStyle.slogan" />
      </div>
    </div>
    <div class="right-wrapper">
      <Base :dataSource="dataSource.base.character" />
      <Skill :dataSource="dataSource.base.skill" :notes="notes" />
      <Attr :dataSource="dataSource.base.attr" />
      <Team :dataSource="dataSource.base.force" />
      <Conversation :dataSource="dataSource.base.conversation" />
      <Videos :dataSource="dataSource.base.videos" />
      <!-- 评论 -->
      <slot></slot>
    </div>

    <!-- 分享弹窗 -->
    <ShareView
      ref="shareView"
      :detail="detail"
      :user="detail.user"
      :dataSource="dataSource"
      :currentStyle="currentStyle"
    />
  </div>
</template>

<script>
import SwitchOptions from "./components/switch.vue";
import Live2d from "./components/live2d.vue";
import LH from "./components/lh.vue";
import Voice from "./components/voice.vue";
import SDModel from "./components/sdModel.vue";
import Dzdh from "./components/dzdh.vue";
import Slogan from "./components/slogan.vue";
import Base from "./components/base.vue";
import Skill from "./components/skill.vue";
import Attr from "./components/attr.vue";
import Team from "./components/team.vue";
import Conversation from "./components/conversation.vue";
import Videos from "./components/videos.vue";
import ShareView from "./shareView.vue";
// entry
import { entry } from "../entry.js";
import { mapGetters } from "vuex";
// formatData
import { formatData } from "../utils.js";

const entryMap = JSON.parse(JSON.stringify(entry));
export default {
  name: "WikiNikkeTJ",
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          content_json: "",
          entry_data_bind: []
        };
      }
    }
  },
  components: {
    SwitchOptions,
    Live2d,
    LH,
    Voice,
    SDModel,
    Dzdh,
    Slogan,
    Base,
    Skill,
    Attr,
    Team,
    Conversation,
    Videos,
    ShareView
  },
  data() {
    return {
      hasHistory: true,
      tabActive: 0,

      dataSource: entryMap,
      currentStyle: { key: "style1", ...entryMap.style.style1 },
      notes: [],
      asideBarStyle: {},
      showType: "0_0"
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  watch: {
    detail: {
      handler(val) {
        if (!val.content_json) return;
        const dataSource = formatData(val.content_json, val.entry_data_bind, entryMap);
        this.dataSource = dataSource;
        this.currentStyle = { key: "style1", ...this.dataSource.style["style1"] };
        this.notes = Object.keys(dataSource.base.notes)
          .filter(key => {
            return dataSource.base.notes[key].label.value && dataSource.base.notes[key].label.hasValue;
          })
          .map((key, index) => {
            return {
              label: dataSource.base.notes[key].label.value,
              value: dataSource.base.notes[key].value.value
            };
          });
      },
      // deep: true,
      immediate: true
    }
  },
  mounted() {},

  methods: {
    switchStyle(key) {
      console.log(key);
      this.currentStyle = { key, ...this.dataSource.style[key] };
    },
    handleSwitch(type) {
      console.log(type);
      this.showType = type;
    }
  }
};
</script>

<style lang="less" scoped>
.tj-container {
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
  width: 100%;
  height: 100%;
  background: rgba(174, 181, 203, 0.2);
  border-radius: 12px;
  padding: 10px;
  display: flex;
  gap: 20px;
  .left-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 583px;
    height: calc(100vh - 96px);
    .left-top {
      flex: 1;
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 8px;
      // background-image: url("~@/assets/nikke_imgs/left-box-bg.png");
      background-color: rgba(255, 255, 255, 0.8);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      backdrop-filter: blur(5px);
    }
    .left-bottom {
      position: absolute;
      z-index: 1;
      width: calc(100% - 20px);
      left: 10px;
      bottom: 10px;
      flex-shrink: 0;
    }
  }

  .right-wrapper {
    width: 600px;
    max-height: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
